export const MOCK_COURSES = [
  {
    id: 'nc-1',
    name: 'Administratör',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-administrator',
    public: 1,
    currency: 'SEK',
    price: { gross: 11500, net: 11500, discounted: 11500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/1891e7df731f56b8b3a24c20a3f5eb92/3bf40e22e0d992e0e6d7455c9259d2c5/826e6ebae6756b4c227071eebd9d6c7d138e51d3f2c4c457b11f167c83908db1.jpg' }],
    categories: [
      { slug: 'economics', name: 'Ekonomi' },
      { slug: 'law', name: 'Juridik' },
      { slug: 'administration', name: 'Administration' },
    ],
    type: 2,
    courses: Array(3).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-3',
    name: 'Apoteksassistent',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-apoteksassistent',
    public: 1,
    currency: 'SEK',
    price: { gross: 15250, net: 15250, discounted: 15250 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/86f0760891fc63eb330fde2a1f813b42/6980853cd6a308445ae6b89893547d58/bbfdcb81b16cc125d87483b87120adc56bca3bac42af2177c2ba016e3233f712.jpg' }],
    categories: [{ slug: 'health', name: 'Hälsa' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-5',
    name: 'Art Director',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-art-director',
    public: 1,
    currency: 'SEK',
    price: { gross: 19500, net: 19500, discounted: 19500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/4b92876f51e931bf3b1e525279cfe6c3/d5fe6a557d2fe6d3c46981ce00fe7af0/a70351d1fb9a51c373ccba087c7bee9b6eab259d068f432702f8de92838e49ab.jpg' }],
    categories: [{ slug: 'design', name: 'Design' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-6',
    name: 'Affärsjuridik',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'affarsjuridik',
    public: 1,
    currency: 'SEK',
    price: { gross: 3750, net: 3750, discounted: 3750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/3b532b42dff50859e0ba551a9593e9ca/89b0a2f904ed72700becd597c97574ac/f2e1b362cef8e0dc5aad6c1de04d70fdabb1e18ba38afada5df7bd4246649cc9.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'law', name: 'Juridik' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-7',
    name: 'Arbetsrätt',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'arbetsratt',
    public: 1,
    currency: 'SEK',
    price: { gross: 3750, net: 3750, discounted: 3750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/1bad38759389cb924b86db6a90f39def/e30a949f956fea4676eb9c13b199f5af/1cda3b2f1d455c7f5f528dfc8bf76c46a26cae498f59500c076ba746981d85c4.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'law', name: 'Juridik' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-8',
    name: 'Associationsrätt',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'associationsratt',
    public: 1,
    currency: 'SEK',
    price: { gross: 3750, net: 3750, discounted: 3750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/0fa28ba18c41f46baf4f3a7dfcf296c8/c9b89a2afca6e38a8a945d024011fc44/a7b6de5eb6ea36dea2a5d72b65bac64d1c972c4a8aec051f3df2fcd7e46f6ae4.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'law', name: 'Juridik' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-9',
    name: 'Avtals- och köprätt',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'avtals-kopratt',
    public: 1,
    currency: 'SEK',
    price: { gross: 3750, net: 3750, discounted: 3750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/e00534a75ba2dda9601721c6a31764a6/3d789b02d0ae2dbc80363804ed4de5a8/4761929e34cb3881e1cb9b33e4cf11f84647c94e119cf533b4ead576a590ccb0.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'law', name: 'Juridik' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-10',
    name: 'Barnskötare',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-barnskotare',
    public: 1,
    currency: 'SEK',
    price: { gross: 15900, net: 15900, discounted: 15900 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/25747d3cfdd248a3d89a22ffd3f59f24/0ebfe01115c7f34fd90ff9d1897b1bde/89cb4df47710e32e267e703ecf30f43d405ca3590a70cb0c253b860dd13313c7.jpg' }],
    categories: [{ slug: 'children-youth', name: 'Barn' }],
    type: 2,
    courses: Array(8).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-11',
    name: 'Beteendeterapeut',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-beteendeterapeut',
    public: 1,
    currency: 'SEK',
    price: { gross: 16900, net: 16900, discounted: 16900 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/d3b27ff2c6816c78c802b906f9a51493/e4d279754edba3c5b2cd55509f4d88cd/4a7fa8cc4ae03ce016b1be157a0e4d717c3ca22aba633031d43807322d64c8c8.jpg' }],
    categories: [{ slug: 'education', name: 'Vård' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-12',
    name: 'BID Manager',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-bid-manager',
    public: 1,
    currency: 'SEK',
    price: { gross: 12500, net: 12500, discounted: 12500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/4538c3413d98b76845d8ce41f69c2e1f/ecdecf2089a816a4870985229971b58f/6c848e4675b020a5226669f9dd4ce12981097bfc757b3ff6f86d225430b3d5be.jpg' }],
    categories: [
      { slug: 'sales-marketing', name: 'Försäljning & Marknadsföring' },
    ],
    type: 2,
    courses: Array(5).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-13',
    name: 'Bokföring 1',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'bokforing-1-grundkurs',
    public: 1,
    currency: 'SEK',
    price: { gross: 4625, net: 4625, discounted: 4625 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/20a13645734871e9c391a2dd9c86a93c/af3dd3db8d18998b97baa573c33bf47d/c1fceb4e09dab9461ea402194a856dfd2708f4f91f09764a04b055d575d52b30.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'economics', name: 'Ekonomi' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-14',
    name: 'Bokföring 2',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'bokforing-2-fortsattningskurs',
    public: 1,
    currency: 'SEK',
    price: { gross: 4465, net: 4465, discounted: 4465 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/c2d5634394c7f3ff2ee609e215353847/16e9f32a735a90046ee8a963c02c9c07/a1dae13036a46a91d4e9ae19a453ee5570470a0d1a8000eea5ac9021f6039820.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'economics', name: 'Ekonomi' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-15',
    name: 'Business Intelligence',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'diplomerad-business-intelligence',
    public: 1,
    currency: 'SEK',
    price: { gross: 14900, net: 14900, discounted: 14900 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/0535ddd72ebd342a3f690e9d68ffa711/91cdfeb57c48cf45b6641f4e230632f5/1702aa629c610290471cb8ca22062496aa88f2333d11a14e0b7cf451bf7c98b8.jpg' }],
    categories: [
      { slug: 'economics', name: 'Ekonomi' },
      { slug: 'law', name: 'Juridik' },
      { slug: 'administration', name: 'Administration' },
    ],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: false,
  },
  {
    id: 'nc-16',
    name: 'Business Manager',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-business-manager',
    public: 1,
    currency: 'SEK',
    price: { gross: 12900, net: 12900, discounted: 12900 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/7198ae6f4f628cf93c32646d25572fa4/5bfaea5c9d0d60cbeae0be90ae754c9a/578cd4c6fdc00bc89bc82265e21b8a3934df1f72ff98a4d7d797d2e2eeb712a5.jpg' }],
    categories: [
      { slug: 'economics', name: 'Ekonomi' },
      { slug: 'law', name: 'Juridik' },
      { slug: 'administration', name: 'Administration' },
    ],
    type: 2,
    courses: Array(3).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-17',
    name: 'Butikschef',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-butikschef',
    public: 1,
    currency: 'SEK',
    price: { gross: 23500, net: 23500, discounted: 23500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/52773c6727731300d87ab2c0dfcb6f9a/9ee31ff007137ef80f9487b157ae33df/6299a756a6b86ed9ddbe716e86ec106e03c5bff5f21fefa0737ba51ecf291f20.jpg' }],
    categories: [{ slug: 'sales-marketing', name: 'Försäljning' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-18',
    name: 'Copywriter',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-copywriter',
    public: 1,
    currency: 'SEK',
    price: { gross: 12900, net: 12900, discounted: 12900 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/daad1370b1464681b37d9af1f0eab9e4/92370c7f6a9b7c49da8662971de1cb2c/36a36a4873c72e64afad4cbb2985ca528f49e6975d5049c9d1fca52ffde66745.png' }],
    categories: [
      { slug: 'technology', name: 'IT & Teknik' },
      { slug: 'media', name: 'Media' },
    ],
    type: 2,
    courses: Array(5).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-19',
    name: 'Entreprenör',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-entreprenor',
    public: 1,
    currency: 'SEK',
    price: { gross: 13700, net: 13700, discounted: 13700 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/db50992713bc58ebd908702467003073/123e177f8b5f8d8906812d7cd39e73c0/b5db6f220490cc83eee1bce2c535ee2559c9dd9ddbd2e0a019953a5f130ce9df.jpg' }],
    categories: [{ slug: 'sales-marketing', name: 'Försäljning' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-20',
    name: 'Feng Shui Konsult',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-feng-shui-konsult',
    public: 1,
    currency: 'SEK',
    price: { gross: 19000, net: 19000, discounted: 19000 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/8f6594ce0ba7fe644ebdeafca5202a9d/6c2ea42ce516e5fc9673324929f2d6a3/67d81759ba70b9ad26411abfeef22d12d7f7abfb9d8d5028fd25b77e66ccb809.jpg' }],
    categories: [{ slug: 'design', name: 'Design' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-21',
    name: 'Företagsekonom',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-foretagsekonom',
    public: 1,
    currency: 'SEK',
    price: { gross: 28500, net: 28500, discounted: 28500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/75be7cef69a247b99b8b237d4e0aac5d/d9901a88a6a1af2342c122aa8c2b667f/2acf3c6446bff75de86153cc3ecee06e833b91666cb1c07b687758ca01fcef53.jpg' }],
    categories: [
      { slug: 'sales-marketing', name: 'Försäljning' },
      { slug: 'economics', name: 'Ekonomi' },
    ],
    type: 2,
    courses: Array(10).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-22',
    name: 'Ekonomi och företagande',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'ekonomi-foretagande',
    public: 1,
    currency: 'SEK',
    price: { gross: 3750, net: 3750, discounted: 3750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/a27d479ea2eb8f72b675d9797260f2b0/d6227b89939e5fed84fc40eb1b24c7ea/2271dfb7c72ad89032a31ba9105c1dc13eb725a9fa661f0e577884f00360f160.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'economics', name: 'Ekonomi' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-23',
    name: 'Ekonomistyrning',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'ekonomistyrning',
    public: 1,
    currency: 'SEK',
    price: { gross: 4625, net: 4625, discounted: 4625 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/9c321af53aadc7b52b8338af29c62158/8b5acaa4b0b0081c7d8ec6fa49a918d1/19ae6f61e0addb8bd350bedc69f811f75265b4669badde446e8592ef0bc3b67d.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'economics', name: 'Ekonomi' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-24',
    name: 'Grafisk Designer',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-grafisk-designer',
    public: 1,
    currency: 'SEK',
    price: { gross: 12500, net: 12500, discounted: 12500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/968d012c051e6398b6cc5db7a57afdb5/7ca98deb3801cf4cb852ee8672536857/4d8d65c09cb68f19498821732b3dd8778473ec4205fd68783d8414fc67412610.jpg' }],
    categories: [{ slug: 'design', name: 'Design' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-25',
    name: 'Homestylist',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-homestylist',
    public: 1,
    currency: 'SEK',
    price: { gross: 12000, net: 12000, discounted: 12000 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/787daae89bfe5d5f9915411c9a9f5666/fe5b9e9d9330df8f53b89feaa7618d16/24c6ff58c68d469e842aad15d2217e10695e75ebb1baea9facb4298012030f4d.jpg' }],
    categories: [{ slug: 'design', name: 'Design' }],
    type: 2,
    courses: Array(2).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-26',
    name: 'Hotel Manager',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-hotel-manager',
    public: 1,
    currency: 'SEK',
    price: { gross: 23500, net: 23500, discounted: 23500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/9bf89416ce3472e3bb55d491b1cccc08/2811406348174f51d667e8037df877e8/8767104211898f1dd90bbb2ae6929e390981b2841f60635011cbbf036b62a7ae.jpg' }],
    categories: [{ slug: 'tourism', name: 'Tourism' }],
    type: 2,
    courses: Array(6).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-27',
    name: 'Inköpsassistent',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-inkopsassistent',
    public: 1,
    currency: 'SEK',
    price: { gross: 11500, net: 11500, discounted: 11500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/21ee28987c9ca0225aeb212444f1c170/a9a044c6e95ab79644753ce859f9d996/649b9f38b0bac617979768d0787a18fc7b968f97f8afc42e4474035cbcb64a40.jpg' }],
    categories: [{ slug: 'sales-marketing', name: 'Försäljning' }],
    type: 2,
    courses: Array(8).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-28',
    name: 'Inredningsarkitekt',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-inredningsarkitekt',
    public: 1,
    currency: 'SEK',
    price: { gross: 24000, net: 24000, discounted: 24000 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/798d7f6419acdd5eca0b152927a71f8a/582adfd1c8337935e1a630b966ae9e0a/eb56aba1b331b2abe059844b65e0547d903fe50fe453aa087d73f24f544d98d6.jpg' }],
    categories: [
      { slug: 'interior-design', name: 'Inredning' },
      { slug: 'design', name: 'Design' },
    ],
    type: 2,
    courses: Array(3).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-29',
    name: 'Journalist',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-journalist',
    public: 1,
    currency: 'SEK',
    price: { gross: 16500, net: 16500, discounted: 16500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/d033d8cf8c6a9562b6a0ad08aee76030/170059ba59473297c286ccf69f740d7a/8bdf75636c09ef7e4cf0005baaee32d0ed958046f8803320c03005f953a71796.jpg' }],
    categories: [{ slug: 'media', name: 'Media' }],
    type: 2,
    courses: Array(5).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-30',
    name: 'Kriminolog',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-kriminolog-2',
    public: 1,
    currency: 'SEK',
    price: { gross: 18900, net: 18900, discounted: 18900 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/23aaa40b8b48ba0a7bb2d305c8cfdd96/df195da8e617fd6527ae6448dd2761f3/f24de098057e322969f12914d5b46452b1ca4711f085ca03ffe909d568e5072e.jpg' }],
    categories: [{ slug: 'other', name: 'Övrigt' }],
    type: 2,
    courses: Array(5).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-31',
    name: 'Juridisk översiktskurs - JÖKEN +',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'diplomerad-juridisk-oversiktskurs-joken',
    public: 1,
    currency: 'SEK',
    price: { gross: 9900, net: 9900, discounted: 9900 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/280aabb54285ec2f1a8ba4beefee029e/2f14bad84dcce40f677d3ca3dcee6f4b/68f076245e611fba73884a2a772ebaf2a85c192c623794e1eea6f02ceee1ef03.jpg' }],
    categories: [
      { slug: 'economics', name: 'Ekonomi' },
      { slug: 'law', name: 'Juridik' },
      { slug: 'administration', name: 'Administration' },
    ],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: false,
  },
  {
    id: 'nc-32',
    name: 'Ledare',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-ledare',
    public: 1,
    currency: 'SEK',
    price: { gross: 13750, net: 13750, discounted: 13750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/9f9c87664e884457fbe4d737f58f7554/452eae86b23a988890a3ae08d9de69ed/daa40f6e405b26f14aa01c070b1df24d4daa84945583afe3ae9febf14a877a6b.jpg' }],
    categories: [
      { slug: 'organisation', name: 'Organisation' },
      { slug: 'leadership', name: 'Ledarskap' },
    ],
    type: 2,
    courses: Array(6).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-33',
    name: 'Marknadsassistent',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-marknadsassistent',
    public: 1,
    currency: 'SEK',
    price: { gross: 14500, net: 14500, discounted: 14500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/b18d9da066e0146c65f841160012c497/8dbf90259ddb48139b7073fc6580b152/eed1926393c8ce13dfc1fefb61adf48a3aaf70a8b99c03add55e6adc8ec51290.jpg' }],
    categories: [
      { slug: 'economics', name: 'Ekonomi' },
      { slug: 'law', name: 'Juridik' },
      { slug: 'administration', name: 'Administration' },
    ],
    type: 2,
    courses: Array(5).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-34',
    name: 'Marknadsekonom',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-marknadsekonom',
    public: 1,
    currency: 'SEK',
    price: { gross: 18500, net: 18500, discounted: 18500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/4f12ee25ec880c29a0a67218e06dab32/503b48f75f1bd4745cc4d87ad790cd55/8a341b7ccabfc930ab18c1512f5340664bec37a1905c48dadcef03c2f7db5ca8.jpg' }],
    categories: [
      { slug: 'economics', name: 'Ekonomi' },
      { slug: 'law', name: 'Juridik' },
      { slug: 'administration', name: 'Administration' },
    ],
    type: 2,
    courses: Array(7).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-35',
    name: 'Marknadsföring och försäljning',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'marknadsforing-forsaljning',
    public: 1,
    currency: 'SEK',
    price: { gross: 3750, net: 3750, discounted: 3750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/ea70433c8ac33af906e8763963c21bfb/00dc648db3f1f0d6df76725d124fc517/ff3cfd707c2a320d9c2c70d347aaef69ff52732fd23665b4b5765c9e4bcc01fa.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'sales-marketing', name: 'Marknadsföring' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-36',
    name: 'Marknadsrätt',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'marknadsratt',
    public: 1,
    currency: 'SEK',
    price: { gross: 3750, net: 3750, discounted: 3750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/700cb258ba04e3ccd6ff3447b32d1ac0/c967a04dbf864858ce8fefe98fdb3d75/2dc06f9d009f7dd693ffa8953a77da895fc3ac88822d162267162b6a42159582' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'law', name: 'Juridik' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-37',
    name: 'Minnesträning för vardagshjärnan',
    ownerName: 'Mattias Ribbing',
    ownerSlug: 'coursionetwork',
    slug: 'minnestraning-for-vardagshjarnan',
    public: 1,
    currency: 'SEK',
    price: { gross: 490, net: 490, discounted: 490 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/ae26a19eca147e874d12b9749a3fb2b7/6dbee13d28a2cabe5d24fa72f1b4d7e0/162fb0816ad514f0bb39cb95d8c368429815ffd859298b2292e7df254e635c67.jpg' }],
    categories: [{ slug: 'self-help', name: 'Personlig utveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-38',
    name: 'Offentlig upphandlare',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-offentlig-upphandlare',
    public: 1,
    currency: 'SEK',
    price: { gross: 12500, net: 12500, discounted: 12500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/68dacbccb3f643435ca06310c96fa73e/89ec172745c47baa28dab7e3cccabf32/0b4efd1b123f9aafd97413f94815b5a17c506b54c017eae560e532fac3697405.jpg' }],
    categories: [
      { slug: 'economics', name: 'Ekonomi' },
      { slug: 'law', name: 'Juridik' },
    ],
    type: 2,
    courses: Array(2).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-39',
    name: 'Officepaketet',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-expert-pa-officepaketet',
    public: 1,
    currency: 'SEK',
    price: { gross: 12500, net: 12500, discounted: 12500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/cb2ef1f754a373d5057d4ceb9eaf63eb/223b6809a4b88d89994d6000aee329e7/0e40db95274371da5eef3fa96d6833d5a77d18fc4225f46f312444efed266895' }],
    categories: [
      { slug: 'technology', name: 'IT & Teknik' },
      { slug: 'media', name: 'Media' },
    ],
    type: 2,
    courses: Array(5).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-40',
    name: 'Organisation',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'organisation',
    public: 1,
    currency: 'SEK',
    price: { gross: 3750, net: 3750, discounted: 3750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/a1bd6e1d9cbaa7719af13d0429a3eb65/cd08254760a429ef49684b44049f2f2c/552d37ad4a34bec9ff09f5da20dd8e8ac6c8c27cf88b0fe23ab055aeb8abe4f2.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'organisation', name: 'Organisation' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-41',
    name: 'Personlig assistent',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-personlig-assistent',
    public: 1,
    currency: 'SEK',
    price: { gross: 12900, net: 12900, discounted: 12900 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/92d40b7288cda1f7a21053657bad5398/df7bd1a699198cc7cb700763b14d20ae/a3dc2a9f7ba6de02a4e11bc26d177a32dcdf8dfb8f9755418dfe25aeaf6ec0b0.jpg' }],
    categories: [{ slug: 'education', name: 'Vård' }],
    type: 2,
    courses: Array(7).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-42',
    name: 'Psykologi',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-i-amnen-inom-psykologi',
    public: 1,
    currency: 'SEK',
    price: { gross: 15900, net: 15900, discounted: 15900 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/17d9d5b4fd5fa7d118875ae38b4304be/0101cfe07a33343551017ce699c6a3fc/628f9ec66ce555a4754e7cd2d81b5bd1c57ecdc8e62313c45e739a1b5a717fc8.jpg' }],
    categories: [{ slug: 'education', name: 'Vård' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-43',
    name: 'Registrator',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-registrator',
    public: 1,
    currency: 'SEK',
    price: { gross: 13950, net: 13950, discounted: 13950 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/0ceacb27bcf74ea0bff327924c8aad97/d6898d3498ea900905ea6765b1732bd1/fc9d5af7baf28df46b40095f71d9ea87c000946bd875b83615d9fab389cf0132.jpg' }],
    categories: [
      { slug: 'economics', name: 'Ekonomi' },
      { slug: 'law', name: 'Juridik' },
    ],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-44',
    name: 'Vårdadministratör',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-vardadministrator',
    public: 1,
    currency: 'SEK',
    price: { gross: 19800, net: 19800, discounted: 19800 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/b9e01360f6516b93ec860717d6a1c8ef/4251111f18241baa660efa119536e634/3c9aacc71f4ba6a004d04a86e35e90ce25c7a1667c58ee30dcf270ab5bdcf2fa.jpg' }],
    categories: [{ slug: 'education', name: 'Vård' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-45',
    name: 'Vårdbiträde',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierat-vardbitrade',
    public: 1,
    currency: 'SEK',
    price: { gross: 12900, net: 12900, discounted: 12900 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/fa49e9681d1419dcb4a00c7aa49cff15/60e769ae2938fcd8c5c30d4804adf022/d8aa1fbbd2c1228f16ab92ba2e386ae86a4b33c091a3c39e49cc00d31149d784.jpg' }],
    categories: [{ slug: 'education', name: 'Vård' }],
    type: 2,
    courses: Array(7).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-46',
    name: 'Privatekonomi',
    ownerName: 'Ekonomiska lifehacks',
    ownerSlug: 'ekonomiskalifehacks',
    slug: 'ekonomiska-lifehacks-programmet',
    public: 1,
    currency: 'SEK',
    price: { gross: 1295, net: 1295, discounted: 1295 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/4a32a2a385d2a73b0a9ef25adb66c240/f5305b128e6259bbb32518f9c9109ac4/0ca8505fc6b198d9434a9fe385d1cacf8f70253f83ca68f1da5a7a9f317ac3ee.png' }],
    categories: [{ slug: 'self-help', name: 'Personlig utveckling' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: false,
  },
  {
    id: 'nc-47',
    name: 'Redovisning 1',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'redovisning-1-grundkurs-2',
    public: 1,
    currency: 'SEK',
    price: { gross: 4625, net: 4625, discounted: 4625 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/510b5852c860899188a22e502bf07ae7/610dd286b5cbfec8c543d524a9b5e6c2/78da82b5117a1ced26f8daf77c13ee49670030a07c7814732d288482234570b3.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'economics', name: 'Ekonomi' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-48',
    name: 'Redovisning 2',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'redovisning-2-fortsattningskurs',
    public: 1,
    currency: 'SEK',
    price: { gross: 4465, net: 4465, discounted: 4465 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/30d6dfabac2fa7c24967527bbd9ed2a1/e1a827571bc35a3a289bcb4f1914a02c/1df9cea0b3b017ab817c9872a01e43764a3e4474fdd23813896273adcc6d7f58.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'economics', name: 'Ekonomi' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-49',
    name: 'Redovisningsekonom',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'certifierad-redovisningsekonom-2',
    public: 1,
    currency: 'SEK',
    price: { gross: 19750, net: 19750, discounted: 19750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/271e3842e2948b4b006c33c59d08d9fa/2b26236a594f1cc78b054d1b2624187a/43b6c3b98befd6209144bc5b49f9e36ad0a376c2a8d3893ef8fdcab27cc10df2.jpg' }],
    categories: [
      { slug: 'economics', name: 'Ekonomi' },
      { slug: 'law', name: 'Juridik' },
    ],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: true,
  },
  {
    id: 'nc-50',
    name: 'Räkenskapsanalys',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'rakenskapsanalys',
    public: 1,
    currency: 'SEK',
    price: { gross: 3750, net: 3750, discounted: 3750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/7e8a6685f429bd4d102e03d3b31dec4d/6432756b1b85611d54bfc63683f895c2/b8326ae711206164ea26ca3365fea26aa5a3d19607a016d7ac76dcded016b2ac.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'economics', name: 'Ekonomi' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-51',
    name: 'Skriv vinnande anbud delkurs 2',
    ownerName: 'Upphandlingsakademin',
    ownerSlug: 'upphandlingsakademin',
    slug: 'lou-smart-start-delkurs-2',
    public: 1,
    currency: 'SEK',
    price: { gross: 3996, net: 3996, discounted: 3996 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/cb082d1e892e0427b8fb5d5e8e7a722f/afc08b1e61a3df366ea3633f64883d7d/beba0b79d6e4b12a6e8b74e4b09b5801637ef4c6b4b09237da4430cd87207a74.png' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'procurement', name: 'Upphandling' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-52',
    name: 'Videoredigerare',
    ownerName: 'Academy Online',
    ownerSlug: 'academyonline',
    slug: 'diplomerad-videoredigerare',
    public: 1,
    currency: 'SEK',
    price: { gross: 6760, net: 6760, discounted: 6760 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/7222c33e94be0337c30f901540374816/462033fa9777f7e52efca62d3d6459dd/daafdbbd05d33535390bc2adf0c112d93d1dcdf5cfee548c1113323f5cbfef12.jpg' }],
    categories: [
      { slug: 'technology', name: 'IT & Teknik' },
      { slug: 'media', name: 'Media' },
    ],
    type: 2,
    courses: Array(3).fill({}),
    hasCertificate: false,
  },
  {
    id: 'nc-53',
    name: 'Vinn nästa upphandling delkurs 1',
    ownerName: 'Upphandlingsakademin',
    ownerSlug: 'upphandlingsakademin',
    slug: 'lou-smart-start-delkurs-1',
    public: 1,
    currency: 'SEK',
    price: { gross: 4796, net: 4796, discounted: 4796 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/e6f90f938d74896b34054d2d2ab8a7c2/21636d8d601b50c5560dcb9f321302e2/007f8e3af74cb84f6a4019ae1295a1cdca36e5669338f09764b2cd478afb3bf3.png' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'procurement', name: 'Upphandling' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-54',
    name: 'AI för arbete',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'ai-for-arbete',
    public: 1,
    currency: 'SEK',
    price: { gross: 2488, net: 2488, discounted: 2488 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/db35741a9d9ef6b078d9f303e5219b5f/a2258deeb7030775e4ad9a3eaac08c66/b90da0ce9c41b9a41f39ec1c51fe55466129a5d9e0e59cb24c65d5f8ae56f667.png' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'technology', name: 'Tech' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-55',
    name: 'Systematiskt Brandskyddsarbete (SBA)',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'systematiskt-brandskyddsarbete-sba',
    public: 1,
    currency: 'SEK',
    price: { gross: 2750, net: 2750, discounted: 2750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/dcce8fdf4c53236bc3890a006372f0ff/511d64e47d28e1ce75ffa63645e5372d/ce41605aca755675766a652b727329dd26572cbbc883852bdb99b575d402cdc4.png' }],
    categories: [{ slug: 'other', name: 'Övrigt' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-56',
    name: 'Basic Coaching',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'basic-coaching',
    public: 1,
    currency: 'SEK',
    price: { gross: 2400, net: 2400, discounted: 2400 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/df698634c74b864fff0c48c3c4875fde/e4ccb436693c7b40cd2becd278af6bdd/5f4fcfcd14f10dcacd7b96b52760655888b0695688845b75b0c7b5d82fd81bc0.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-57',
    name: 'Personalekonomi',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'personalekonomi',
    public: 1,
    currency: 'SEK',
    price: { gross: 3500, net: 3500, discounted: 3500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/58edf754280ad5f1d8b7a1adacf7802b/9253b39b4c8aeef9c5a19a293da6fecb/be26a48c33d652679529aaeddf4d0dd9ba0076f893a59c3a0b2ba09d33c7a976.jpg' }],
    categories: [{ slug: 'economics', name: 'Ekonomi' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-58',
    name: 'Entreprenör komplett 1-4',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'entreprenor-komplett-1-4',
    public: 1,
    currency: 'SEK',
    price: { gross: 12375, net: 12375, discounted: 12375 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/ea9881a51fe320d8f3fede3ff459f820/fe78c7901a4d4929b174232d56d7a785/9ecc36f4c1039ef7f77498398425e37574d09200baa821b5f7bd1dd7efef23fa.png' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: false,
  },
  {
    id: 'nc-59',
    name: 'Entreprenör 1 - Entreprenörskap & företagsformer',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'entreprenor-1-entreprenorskap-foretagsformer',
    public: 1,
    currency: 'SEK',
    price: { gross: 3425, net: 3425, discounted: 3425 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/ce1a112ff29b4e6d1bb1bb1d99edbd59/c367e7ca982e36395cdda7feca1ef864/0febcc241d9389efba22edd25bf772f421415d4205aaf2514d8666aeafca4814.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-60',
    name: 'Entreprenör 2 - Starta-driva-sälja-juridik-partners',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'entreprenor-2-starta-driva-salja-juridik-partners',
    public: 1,
    currency: 'SEK',
    price: { gross: 3425, net: 3425, discounted: 3425 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/2386575ab5c7321771d968d7d052e0c8/e9b3fbf095403993d95d95d6efb0888b/28bb5889f88a9cce12387bfd58750f811a84c6bab726466c6bb9b9a2d64894da.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-61',
    name: 'Entreprenör 3 - Ekonomi',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'entreprenor-3-ekonomi',
    public: 1,
    currency: 'SEK',
    price: { gross: 3425, net: 3425, discounted: 3425 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/9c321af53aadc7b52b8338af29c62158/8b5acaa4b0b0081c7d8ec6fa49a918d1/19ae6f61e0addb8bd350bedc69f811f75265b4669badde446e8592ef0bc3b67d.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-62',
    name: 'Entreprenör 4 - Organisation-personal-kommunikation',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'entreprenor-4-organisation-personal-kommunikation',
    public: 1,
    currency: 'SEK',
    price: { gross: 3425, net: 3425, discounted: 3425 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/6173130a60ee013338d0cfb4bbc5e8bd/a9b52e5ae407940b9e0c0de7b336040f/e7bfae35359c58be866e3787936a58832c424911f5178b436fcee53fbc0a3209.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-63',
    name: 'Business Manager komplett 1-3',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'business-manager-komplett-1-3',
    public: 1,
    currency: 'SEK',
    price: { gross: 8500, net: 8500, discounted: 8500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/a1149de7808193071f2c11ff13f3d355/0706e78cdc22d75e5d71e8eda9bf0b63/568e29a63dc6668f68b9fd6c2b232150583131e921896caa5434d50635c30170.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 2,
    courses: Array(3).fill({}),
    hasCertificate: false,
  },
  {
    id: 'nc-64',
    name: 'Butikschef komplett 1-4',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'butikschef-komplett-1-4',
    public: 1,
    currency: 'SEK',
    price: { gross: 13950, net: 13950, discounted: 13950 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/2233b8b6e6940a0857873ff5ed2df23d/94b8ba50c4f5aa2ede061231a39b5157/9b8a6afccf7945d0e57b08a0ccb09d9f475f43fceb6b5051c98ac1ea9f0006b4.jpg' }],
    categories: [{ slug: 'sales-marketing', name: 'Försäljning' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: false,
  },
  {
    id: 'nc-65',
    name: 'Butikschef 1 - Butiksdrift',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'butikschef-1-butiksdrift',
    public: 1,
    currency: 'SEK',
    price: { gross: 3744, net: 3744, discounted: 3744 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/52773c6727731300d87ab2c0dfcb6f9a/9ee31ff007137ef80f9487b157ae33df/6299a756a6b86ed9ddbe716e86ec106e03c5bff5f21fefa0737ba51ecf291f20.jpg' }],
    categories: [{ slug: 'sales-marketing', name: 'Försäljning' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-66',
    name: 'Butikschef 2 - Ledarskap i butik',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'butikschef-2-ledarskap-i-butik',
    public: 1,
    currency: 'SEK',
    price: { gross: 3744, net: 3744, discounted: 3744 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/52773c6727731300d87ab2c0dfcb6f9a/9ee31ff007137ef80f9487b157ae33df/6299a756a6b86ed9ddbe716e86ec106e03c5bff5f21fefa0737ba51ecf291f20.jpg' }],
    categories: [{ slug: 'sales-marketing', name: 'Försäljning' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-67',
    name: 'Butikschef 3 - Motivera',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'butikschef-3-motivera',
    public: 1,
    currency: 'SEK',
    price: { gross: 3744, net: 3744, discounted: 3744 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/52773c6727731300d87ab2c0dfcb6f9a/9ee31ff007137ef80f9487b157ae33df/6299a756a6b86ed9ddbe716e86ec106e03c5bff5f21fefa0737ba51ecf291f20.jpg' }],
    categories: [{ slug: 'sales-marketing', name: 'Försäljning' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-68',
    name: 'Butikschef 4 - Kundmötet',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'butikschef-4-kundmotet',
    public: 1,
    currency: 'SEK',
    price: { gross: 3744, net: 3744, discounted: 3744 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/52773c6727731300d87ab2c0dfcb6f9a/9ee31ff007137ef80f9487b157ae33df/6299a756a6b86ed9ddbe716e86ec106e03c5bff5f21fefa0737ba51ecf291f20.jpg' }],
    categories: [{ slug: 'sales-marketing', name: 'Försäljning' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-69',
    name: 'Servering',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'servering',
    public: 1,
    currency: 'SEK',
    price: { gross: 995, net: 995, discounted: 995 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/7f8de9c556685047b604472ead8664f6/f45e47cd3755afde6fcd685012109e98/54db87ffb31c57367089574996b2b4f522829e8360272e7a2f4a94021c7e3b6f.jpg' }],
    categories: [{ slug: 'other', name: 'Övrigt' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-70',
    name: 'Rekrytering',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'rekrytering',
    public: 1,
    currency: 'SEK',
    price: { gross: 3500, net: 3500, discounted: 3500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/1617bbb090ca106722f0eb8e3c566ba8/5b2075b6fc97e6a7d399c8c1a0f488e6/ea0f566d07a48530b6e2514e7291f346ece2aa0b6741ec8e26b1b7d103770043.png' }],
    categories: [
      { slug: 'other', name: 'Övrigt' },
      { slug: 'human-resources', name: 'HR' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-71',
    name: 'Cirkulärt Mode',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'cirkulart-mode',
    public: 1,
    currency: 'SEK',
    price: { gross: 4995, net: 4995, discounted: 4995 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/6625f953aa1eddc4b87bac9001ad115a/cb9650dc93659f90e5adbcf7ca45a536/68f83db6ac58be19cf1c6d3c0acae6e5ff0d9b713e91c41c2fd9d4ce5b7d7f2a.jpg' }],
    categories: [{ slug: 'fashion', name: 'Mode' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-72',
    name: 'Florist',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'florist',
    public: 1,
    currency: 'SEK',
    price: { gross: 995, net: 995, discounted: 995 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/d6a13b6992b745c6e18d80a576da0c62/885d14737b6ec0d83a4eea925f8f4c17/7aa59d89a022897c19384bdf0b810e4883a0c50466028890f1fdfafeaa71b9d9.jpg' }],
    categories: [{ slug: 'nature', name: 'Natur' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-73',
    name: 'CLO 3D- design Avatarer',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'clo-3d-design-avatarer',
    public: 1,
    currency: 'SEK',
    price: { gross: 1500, net: 1500, discounted: 1500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/2e18fb1e6990771248798f6f852f7175/a6fa4360c598d3b9a3c4011a6ff50165/dcaacbadf8926ba02a2abd1e6aab12c5c1ca8ba901ee3ed240d7ea4a304a04a7.png' }],
    categories: [
      { slug: 'fashion', name: 'Mode' },
      { slug: 'technology', name: 'IT' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-74',
    name: 'Git, GitHub, Visual Studio Code, Markdown och Trello',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'git-github-visual-studio-code-markdown-och-trello',
    public: 1,
    currency: 'SEK',
    price: { gross: 1875, net: 1875, discounted: 1875 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/62dccc99aded58ff691d5ea928b8580d/29d7c6ca48521b96b0a4468b6ebf70f3/37ea25f51e302a06437d48257e1b66d3d37e331f611a39f57d2d6f0b6f887fc7.png' }],
    categories: [
      { slug: 'technology', name: 'IT & Tech' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-75',
    name: '3D SketchUp - kurs',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: '3d-sketchup-kurs',
    public: 1,
    currency: 'SEK',
    price: { gross: 1975, net: 1975, discounted: 1975 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/6e8fd524e9355168b9ab216952fd95b0/8f8b7958f8cff2f965a1e121ff419e3c/d0f3e88762a3b8d381f0be032603428ab99557270dd4f15299512fe98ee4e824.jpg' }],
    categories: [
      { slug: 'interior-design', name: 'Inredning' },
      { slug: 'technology', name: 'IT' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-76',
    name: 'Juridisk översiktskurs - JÖKEN 1',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'juridisk-oversiktskurs-joken-1',
    public: 1,
    currency: 'SEK',
    price: { gross: 1875, net: 1875, discounted: 1875 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/280aabb54285ec2f1a8ba4beefee029e/2f14bad84dcce40f677d3ca3dcee6f4b/68f076245e611fba73884a2a772ebaf2a85c192c623794e1eea6f02ceee1ef03.jpg' }],
    categories: [{ slug: 'law', name: 'Juridik' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-77',
    name: 'Juridisk översiktskurs - JÖKEN 2',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'juridisk-oversiktskurs-joken-2',
    public: 1,
    currency: 'SEK',
    price: { gross: 3500, net: 3500, discounted: 3500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/280aabb54285ec2f1a8ba4beefee029e/2f14bad84dcce40f677d3ca3dcee6f4b/68f076245e611fba73884a2a772ebaf2a85c192c623794e1eea6f02ceee1ef03.jpg' }],
    categories: [{ slug: 'law', name: 'Juridik' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-78',
    name: 'Juridisk översiktskurs - JÖKEN 3',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'juridisk-oversiktskurs-joken-3',
    public: 1,
    currency: 'SEK',
    price: { gross: 3500, net: 3500, discounted: 3500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/280aabb54285ec2f1a8ba4beefee029e/2f14bad84dcce40f677d3ca3dcee6f4b/68f076245e611fba73884a2a772ebaf2a85c192c623794e1eea6f02ceee1ef03.jpg' }],
    categories: [{ slug: 'law', name: 'Juridik' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-79',
    name: 'Juridisk översiktskurs - JÖKEN 4',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'juridisk-oversiktskurs-joken-4',
    public: 1,
    currency: 'SEK',
    price: { gross: 3500, net: 3500, discounted: 3500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/280aabb54285ec2f1a8ba4beefee029e/2f14bad84dcce40f677d3ca3dcee6f4b/68f076245e611fba73884a2a772ebaf2a85c192c623794e1eea6f02ceee1ef03.jpg' }],
    categories: [{ slug: 'law', name: 'Juridik' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-80',
    name: 'Juridisk översiktskurs hela Jöken 1-4',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'juridisk-oversiktskurs-hela-joken-1-4',
    public: 1,
    currency: 'SEK',
    price: { gross: 9250, net: 9250, discounted: 9250 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/4917c3e1323a1988cd2b420067f8e842/801211c86d0c3508aa59b1dba0154b71/dce9b84e53e14453c1846c39cc9a1076f72504c9694e6401846af0aed223b605.jpg' }],
    categories: [{ slug: 'law', name: 'Juridik' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: false,
  },
  {
    id: 'nc-81',
    name: 'Skadeståndsrätt',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'skadestandsratt',
    public: 1,
    currency: 'SEK',
    price: { gross: 2950, net: 2950, discounted: 2950 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/223dd787c61ad72ca9820cd7dde968b6/14f24083584fb46e37f9fea179b27520/dd550257c60154cec1039b87ee3f68745e38b89f97ceeb44547193e6d044e421.jpg' }],
    categories: [{ slug: 'law', name: 'Juridik' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-82',
    name: 'Straffrätt',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'straffratt',
    public: 1,
    currency: 'SEK',
    price: { gross: 3950, net: 3950, discounted: 3950 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/0349b4191421008cf04ebddea1b64d54/17e0277fa372c03f7777af09e3704466/87483ffe06dfd9433817819a3edf062ef8540cfde5c81db3509b55d7c1f14a0b.jpg' }],
    categories: [{ slug: 'law', name: 'Juridik' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-83',
    name: 'Familjerätt',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'familjeratt',
    public: 1,
    currency: 'SEK',
    price: { gross: 2950, net: 2950, discounted: 2950 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/29cfa2ac0036985dd330ae3dc023242a/4173aa45f0bca81e4919931d95d6a24e/5d3fc0cbc0feb831edf8999771d00529976aa4e097deadaedfea46eaeadb5f94.jpg' }],
    categories: [{ slug: 'law', name: 'Juridik' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-84',
    name: 'Kommunikation i arbetslivet',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'kommunikation-i-arbetslivet',
    public: 1,
    currency: 'SEK',
    price: { gross: 3500, net: 3500, discounted: 3500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/0f3ec866104a7ef7d8d5cb9145c21828/692f51572f6945692bc47ed60ec727c1/8c1ef1dc1d8c2a4c59e5d49378260ba6fe7ce5f70a5dbe7ca68bfce7c6bcdd9e.jpg' }],
    categories: [{ slug: 'communication', name: 'Kommunikation' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-85',
    name: 'Kreativt skrivande',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'kreativt-skrivande',
    public: 1,
    currency: 'SEK',
    price: { gross: 3590, net: 3590, discounted: 3590 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/2bf9fe5d2cf9bdcc46770a0f5fa4dcdb/736acf095fabf92af5e0491896c3a147/b771b7889beae1edc3bc35a028cf0fe68915c35eff80e985625857434bf270ba.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'other', name: 'Övrigt' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-86',
    name: 'Psykosocial arbetsmiljö och självledarskap',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'psykosocial-arbetsmiljo-och-sjalvledarskap',
    public: 1,
    currency: 'SEK',
    price: { gross: 3950, net: 3950, discounted: 3950 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/3d28c22cabf6854c3d1df5991a614a41/2140fe75d3dfc90fda91e5abeb93d9f1/b86fa7617cce276cbfa3e5e1c2d43c9d113d88303127d4fef5e723ab33457b22.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-87',
    name: 'ChatGPT i jobbet',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'chatgpt-i-jobbet',
    public: 1,
    currency: 'SEK',
    price: { gross: 2495, net: 2495, discounted: 2495 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/14d127adb5725135fbe30e2cd4e2e656/4b0c17dbfd9f9321a156c417af070b2e/edc937f458efa88554633fd6fe8ea0d8bf95e53555df5e35258e284add6ca883.png' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'technology', name: 'Tech' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-88',
    name: 'Designassistent',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'designassistent',
    public: 1,
    currency: 'SEK',
    price: { gross: 4900, net: 4900, discounted: 4900 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/e5a2cb4b157caf837d5c5e8f14b95c75/6e27f3f66b865da195d633c143e548ab/c2257ebb1543a5d102641d7e069c4d336152fc05839dc1a13e65bbbb8a85271b.jpg' }],
    categories: [{ slug: 'fashion', name: 'Mode' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-89',
    name: 'Organisationsförändring',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'organisationsforandring',
    public: 1,
    currency: 'SEK',
    price: { gross: 3500, net: 3500, discounted: 3500 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/4e90bc5dd42fc17c7e14a84e9abb6c8f/81261a389aba7c2934f8f5275ee82103/1262e6ede161c03651f30b76adec572740334b7dd4639c45028b0dd3794618b5.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'organisation', name: 'Organisation' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-90',
    name: 'Business Intelligence komplett 1-4',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'business-intelligence-komplett-1-4',
    public: 1,
    currency: 'SEK',
    price: { gross: 9900, net: 9900, discounted: 9900 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/b291513032e0fc210a7946c50bc60c03/55e19d6fc70a895698272be82ef4eecc/b0caf95b72170a2f4985423763d768774859dd4d128dde6dd6ccafed5d277a1e.png' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 2,
    courses: Array(4).fill({}),
    hasCertificate: false,
  },
  {
    id: 'nc-91',
    name: 'Business Intelligence 1 - Introduktion till BI',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'business-intelligence-1-introduktion-till-bi',
    public: 1,
    currency: 'SEK',
    price: { gross: 2750, net: 2750, discounted: 2750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/c91181c08323af7e5daa3acca8678cc9/8402103e71da7f381e83399d0747e2b6/036230716d9f9329e3b0e15af12ac040f3ce1e27c2f206b6458d9b7806132820.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-92',
    name: 'Business Intelligence 2 - Dataåtkomst & marknad',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'business-intelligence-2-dataatkomst-marknad',
    public: 1,
    currency: 'SEK',
    price: { gross: 2750, net: 2750, discounted: 2750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/c91181c08323af7e5daa3acca8678cc9/8402103e71da7f381e83399d0747e2b6/036230716d9f9329e3b0e15af12ac040f3ce1e27c2f206b6458d9b7806132820.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-93',
    name: 'Business Intelligence 3 - Att arbeta med BI',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'business-intelligence-3-att-arbeta-med-bi',
    public: 1,
    currency: 'SEK',
    price: { gross: 2750, net: 2750, discounted: 2750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/c91181c08323af7e5daa3acca8678cc9/8402103e71da7f381e83399d0747e2b6/036230716d9f9329e3b0e15af12ac040f3ce1e27c2f206b6458d9b7806132820.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-94',
    name: 'Business Intelligence 4 - Optimera BI',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'business-intelligence-4-optimera-bi',
    public: 1,
    currency: 'SEK',
    price: { gross: 2750, net: 2750, discounted: 2750 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/c91181c08323af7e5daa3acca8678cc9/8402103e71da7f381e83399d0747e2b6/036230716d9f9329e3b0e15af12ac040f3ce1e27c2f206b6458d9b7806132820.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-95',
    name: 'Business Manager 1 - Organisation',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'business-manager-1-organisation',
    public: 1,
    currency: 'SEK',
    price: { gross: 3000, net: 3000, discounted: 3000 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/a1149de7808193071f2c11ff13f3d355/0706e78cdc22d75e5d71e8eda9bf0b63/568e29a63dc6668f68b9fd6c2b232150583131e921896caa5434d50635c30170.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-96',
    name: 'Business Manager 2 - Affärsmodeller',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'business-manager-2-affarsmodeller',
    public: 1,
    currency: 'SEK',
    price: { gross: 3000, net: 3000, discounted: 3000 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/a1149de7808193071f2c11ff13f3d355/0706e78cdc22d75e5d71e8eda9bf0b63/568e29a63dc6668f68b9fd6c2b232150583131e921896caa5434d50635c30170.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-97',
    name: 'Business Manager 3 - Ekonomistyrning',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'business-manager-3-ekonomistyrning',
    public: 1,
    currency: 'SEK',
    price: { gross: 3000, net: 3000, discounted: 3000 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/a1149de7808193071f2c11ff13f3d355/0706e78cdc22d75e5d71e8eda9bf0b63/568e29a63dc6668f68b9fd6c2b232150583131e921896caa5434d50635c30170.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-98',
    name: 'LEAN Management',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'lean-management',
    public: 1,
    currency: 'SEK',
    price: { gross: 3250, net: 3250, discounted: 3250 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/e05dd6dcd21c51ad6083e81420ef2785/d054e4e9363a8a7b6634d2f2a2388c0f/27e651e23c0a1761fc37d76c1b8b7706b587d708436c7ee09387584ed1669754.jpg' }],
    categories: [{ slug: 'career-development', name: 'Karriärsutveckling' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-99',
    name: 'Personligt Ledarskap',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'personligt-ledarskap',
    public: 1,
    currency: 'SEK',
    price: { gross: 2200, net: 2200, discounted: 2200 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/4e86cf5a4483c43ed5a3fa2b9989cede/c4c8f3330f1fbdc649944f0856626e6e/dfeb46561b5b2c76b1a3e62515c1c832ac14a1d043f69549737226dce9ee8fc7.jpg' }],
    categories: [
      { slug: 'career-development', name: 'Karriärsutveckling' },
      { slug: 'leadership', name: 'Ledarskap' },
    ],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-100',
    name: 'Anatomi grundkurs',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'anatomi-grundkurs',
    public: 1,
    currency: 'SEK',
    price: { gross: 4375, net: 4375, discounted: 4375 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/57aa6f42299c396538d6e6ac5fe573ba/a5d6d6e00082aaabb9e31e719591e68a/076ca80c7dd98812d51c3239fa9af8854d64345262cf888b4dc0740fef9d5604.jpg' }],
    categories: [{ slug: 'education', name: 'Vård' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-101',
    name: 'Anatomi fortsättningskurs',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'anatomi-fortsattningskurs',
    public: 1,
    currency: 'SEK',
    price: { gross: 4375, net: 4375, discounted: 4375 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/57aa6f42299c396538d6e6ac5fe573ba/a5d6d6e00082aaabb9e31e719591e68a/076ca80c7dd98812d51c3239fa9af8854d64345262cf888b4dc0740fef9d5604.jpg' }],
    categories: [{ slug: 'education', name: 'Vård' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-102',
    name: 'Anatomi fördjupningskurs',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'anatomi-fordjupningskurs',
    public: 1,
    currency: 'SEK',
    price: { gross: 4375, net: 4375, discounted: 4375 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/57aa6f42299c396538d6e6ac5fe573ba/a5d6d6e00082aaabb9e31e719591e68a/076ca80c7dd98812d51c3239fa9af8854d64345262cf888b4dc0740fef9d5604.jpg' }],
    categories: [{ slug: 'education', name: 'Vård' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-103',
    name: 'Farmakologi',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'farmakologi',
    public: 1,
    currency: 'SEK',
    price: { gross: 4375, net: 4375, discounted: 4375 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/3cb37794e87e7a8587b6da492b728909/d86c98f8b4f801eeb8f7ebd94d824089/f6230166ad87e13c3b1a2b32033f15294753224cae943515c2a0eb630aaf87be.png' }],
    categories: [{ slug: 'education', name: 'Vård' }],
    type: 1,
    hasCertificate: false,
  },
  {
    id: 'nc-104',
    name: 'Medveten närvaro som stresshantering',
    ownerName: 'Excellence Education',
    ownerSlug: 'excellenceeducation',
    slug: 'medveten-narvaro-som-stresshantering',
    public: 1,
    currency: 'SEK',
    price: { gross: 3950, net: 3950, discounted: 3950 },
    coverImage: [{ url: 'https://coursio.s3-eu-west-1.amazonaws.com/89b6835e3c52567827047e317f9299c0/9c7dedffc61c5579784c0bdc13ba23eb/cc427c9cde257a5d3be7d3a97453a19f5ee85fc80cdc422ec3fb564fe6a3b44b.png' }],
    categories: [{ slug: 'education', name: 'Vård' }],
    type: 1,
    hasCertificate: false,
  },
];

export const MOCK_PROVIDERS = [
  { username: 'academyonline', display_name: 'Academy Online' },
  { username: 'excellenceeducation', display_name: 'Excellence Education' },
  { username: 'coursionetwork', display_name: 'Mattias Ribbing' },
  { username: 'ekonomiskalifehacks', display_name: 'Ekonomiska lifehacks' },
  { username: 'upphandlingsakademin', display_name: 'Upphandlingsakademin' },
];
